export default __webpack_public_path__ + "static/media/hm.1ca4e5ba.svg";